import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ParentService {
  
  testCodeWiseResults(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
      .set('admNo', payload.admNo)
      .set('testCode', payload.testCode);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testCodeWiseResults`, 
      {},
      { headers, params }
    );
  }
  

  constructor( private http:HttpClient) { }
  latestExamResult(token: string, scaitsurl: string, admNo: string) {
    const headers = new HttpHeaders({
      'Authorization': token,
    });
  
    const params = new HttpParams().set('admNo', admNo);
  
    return this.http.post(scaitsurl + '/studentProgressReport/latestExamResult', {}, { headers, params });
  }

  loadTestTypeWiseRankDetails(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
    {},
    { headers, params }
  );
  }

  loadTestTypeWiseSubjectPerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
    {},
    { headers, params }
  );
  
  }

  loadTestTypeWiseTestModePerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

  return this.http.post(
    `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseTestModePerformance`, 
    {},
    { headers, params }
  );

  }


  loadTestTypeWiseExamPerfornamce(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers= new HttpHeaders({
      'Authorization': jwt,
    });
    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseExamPerformance`, 
      {},
      { headers, params }
    );
    
  }
  loadTestTypeAndTestCodeList(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeWiseTestCodes`, 
      {},
      { headers, params }
    );
  }
  loadTestTypeWiseExamPerformance(jwt: any, scaitsWebServiceUrl: any, payload:any) {
    const headers = new HttpHeaders({
      'Authorization': jwt,
    });

    const params = new HttpParams()
    .set('admNo', payload.admNo)
    .set('testType', payload.testType);

    return this.http.post(
      `${scaitsWebServiceUrl}/studentProgressReport/testTypeLatestExamResult`, 
      {},
      { headers, params }
    );
  }

  parentlogin(payload: any) {
    const headers = new HttpHeaders({
      // 'Authorization': 'Basic cGFyZW50OnNlY3JldA==',
      // "Content-Type": 'application/x-www-form-urlencoded'
    });
    return this.http.post(environment.employeeURL + '/jwtV2/student/web/token', payload, { headers })
  }

}
